import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { IUserEntity } from '@wephone-core/model/entity/user.i';
import { UserProfileDialog } from '@wephone-common/modals';
import { DialogService } from '@wephone-utils';
import { ISipphoneEntity } from '@wephone-core/model/entity/sipphone.i';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  sipNumber: string;

  constructor(
    private readonly authService: AuthenticationService,
    private readonly dialogService: DialogService,
  ) {
  }

  ngOnInit(): void {
    const sipphone: ISipphoneEntity = this.currentUser.sipphone;
    this.sipNumber = sipphone && sipphone.extension || '';
  }

  get currentUser(): IUserEntity {
    return this.authService.getUser();
  }

  showUserProfile(): void {
    this.dialogService.openDialog2(UserProfileDialog, {});
  }
}
